/**
 * Shown wherever an account is created (web sign-up, the native sign-up sheet).
 * Every new account is opted into product-update emails, and the API records
 * this wording's version with that opt-in: change the copy here and bump
 * SIGNUP_EMAIL_NOTICE_VERSION (api notificationPreferenceService) with it.
 * This wording is 'signup-notice-v2'.
 */
export const SIGNUP_EMAIL_NOTICE =
  "We'll email you product updates and occasional offers. Opt out any time in settings.";
